import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import moment from "moment";
import { Typography } from "@progress/kendo-react-common";
import { useParams } from "react-router-dom";
import { getExpenseDetailsByID } from "./services/expenseApproved.services";
import { formatIndianNumber } from "../../_helper/helper";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";

const ExpenseDetailsPrint: React.FC = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const expense_details_guid = params?.expense_details_guid;

  const fetchdetailes = async (ID: any) => {
    await dispatch(getExpenseDetailsByID(ID));
    window.print();
  };
  useEffect(() => {
    fetchdetailes(expense_details_guid);
  }, [expense_details_guid]);

  const gridRef = useRef<any>(null);
  const loading = useAppSelector((state) => state.expensedetails.loading);
  const ExpenseDetail = useAppSelector(
    (state) => state.expensedetails.ExpenseDetail
  );
  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}

      <>
        <div
        //   style={{
        //     display: "flex",
        //     justifyContent: "space-between",
        //     alignItems: "start",
        //   }}
        >
          <Typography.h5>Expense Details</Typography.h5>
        </div>
        <ButtonWithLoading
          buttonStyle={{ position: "fixed", right: 0, top: 0, zIndex: 100 }}
          label={"Print"}
          className="no-visible-print-btn"
          type="button"
          onClick={() => window.print()}
        />
        <table
          className="table table-bordered"
          style={{ borderColor: "black" }}
        >
          <tbody>
            <tr>
              <td style={{ backgroundColor: "lightgrey" }}>
                <strong>Expense Date</strong>
              </td>
              <td >
                {moment(ExpenseDetail?.expense_date).format("DD/MM/YYYY")}
              </td>
              <td style={{ backgroundColor: "lightgrey" }}>
                <strong>Sales Representative</strong>
              </td>
              <td>{ExpenseDetail?.sr_name}</td>
            </tr>
            <tr>
              <td style={{ backgroundColor: "lightgrey" }}>
                <strong>To City</strong>
              </td>
              <td>{ExpenseDetail?.to_city_name}</td>
              <td style={{ backgroundColor: "lightgrey" }}>
                <strong>From City</strong>
              </td>
              <td>{ExpenseDetail?.from_city_name}</td>
            </tr>
            <tr>
              <td style={{ backgroundColor: "lightgrey" }}>
                <strong>Mode Of Transport</strong>
              </td>
              <td>{ExpenseDetail?.mode_of_transport_name}</td>
              <td style={{ backgroundColor: "lightgrey" }}>
                <strong>Petrol Allowance</strong>
              </td>
              <td className="text-end">
                {formatIndianNumber(ExpenseDetail?.petrol_rate_per_km || 0)}
              </td>
            </tr>
            <tr>
              <td rowSpan={2} style={{ backgroundColor: "lightgrey" }}>
                <strong>Cities Visited</strong>
              </td>
              <td rowSpan={2}>{ExpenseDetail?.city_town_visisted_name}</td>
              <td style={{ backgroundColor: "lightgrey" }}>
                <strong>Fare For Transport</strong>
              </td>
              <td className="text-end">
                {formatIndianNumber(ExpenseDetail?.fare_for_transport || 0)}
              </td>
            </tr>
            <tr>
              <td style={{ backgroundColor: "lightgrey" }}>
                <strong>Sales Amount</strong>
              </td>
              <td className="text-end">
                {formatIndianNumber(ExpenseDetail?.sales_amount || 0)}
              </td>
            </tr>
            <tr>
              <td style={{ backgroundColor: "lightgrey" }}>
                <strong>Working agent/Area/Town:</strong>
              </td>
              <td colSpan={3}>{ExpenseDetail?.remarks}</td>
            </tr>
          </tbody>
        </table>

        <Typography.h5>Expenses</Typography.h5>
        <table
          className="table table-bordered"
          style={{ borderColor: "black" }}
        >
          <tbody>
            {ExpenseDetail.expense_details_list.map((item: any) => (
              <tr>
                <td style={{ backgroundColor: "lightgrey" }}>
                  <strong>{item?.expense_name?.toUpperCase()}</strong>
                </td>
                <td style={{ textAlign: "end" }}>
                  {formatIndianNumber(item.value || 0)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Typography.h5>Expense Verification</Typography.h5>
        <table
          className="table table-bordered"
          style={{ borderColor: "black" }}
        >
          <tbody>
            <tr>
              <td style={{ backgroundColor: "lightgrey" }}>
                <strong>Verified By</strong>
              </td>
              <td>{ExpenseDetail.verify_by_name}</td>
              <td style={{ backgroundColor: "lightgrey" }}>
                <strong
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  Net Amount <span style={{ color: "green" }}>(A)</span>
                </strong>
              </td>
              <td style={{ textAlign: "end" }}>
                {formatIndianNumber(ExpenseDetail.net_amount || 0)}
              </td>
            </tr>
            <tr>
              <td style={{ backgroundColor: "lightgrey" }}>
                <strong>Verification Date</strong>
              </td>
              <td>
                {ExpenseDetail?.verification_date
                  ? moment(ExpenseDetail?.verification_date).format(
                      "DD/MM/YYYY"
                    )
                  : ""}
              </td>
              <td style={{ backgroundColor: "lightgrey" }}>
                <strong
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  Disallowed Amount
                  <span style={{ color: "red" }}>(B)</span>
                </strong>
              </td>
              <td style={{ textAlign: "end" }}>
                {formatIndianNumber(ExpenseDetail.disallowed_amount || 0)}
              </td>
            </tr>
            <tr>
              <td style={{ backgroundColor: "lightgrey" }}>
                <strong>Verification Status</strong>
              </td>
              <td
                className={
                  ExpenseDetail?.verification_status
                    ? "text-success"
                    : "text-danger"
                }
              >
                <strong>
                  {ExpenseDetail?.verification_status
                    ? "Verified"
                    : "Not Verified"}
                </strong>
              </td>
              <td style={{ backgroundColor: "lightgrey" }}>
                <strong
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  Additional Amount <span style={{ color: "green" }}> (C)</span>
                </strong>
              </td>
              <td style={{ textAlign: "end" }}>
                {formatIndianNumber(
                  ExpenseDetail.additional_expense_amount || 0
                )}
              </td>
            </tr>
            <tr>
              <td style={{ backgroundColor: "lightgrey" }}>
                <strong>Verification Remarks</strong>
              </td>
              <td>{ExpenseDetail?.verification_remarks}</td>
              <td style={{ backgroundColor: "lightgrey" }}>
                <strong
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  Total Amount{" "}
                  <p className="m-0">
                    (<span style={{ color: "green" }}>{"A"}</span> -{" "}
                    <span style={{ color: "red" }}>{"B"}</span> +{" "}
                    <span style={{ color: "green" }}>{"C"}</span>){" "}
                  </p>
                </strong>
              </td>
              <td style={{ textAlign: "end" }}>
                {formatIndianNumber(ExpenseDetail.total_amount || 0)}
              </td>
            </tr>
          </tbody>
        </table>
      </>
    </>
  );
};

export default ExpenseDetailsPrint;
